// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import { VersionableFragmentDoc } from '../../../../components/ReadyPlanVersionHeader.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DesignPackagePersonalizationGroupsPageQueryVariables = Types.Exact<{
  designPackageId: Types.Scalars['ID']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DesignPackagePersonalizationGroupsPageQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, displayName: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } }>, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, active: boolean, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string } | null | undefined, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, personalizationPlaceholders: Array<{ __typename?: 'TakeoffLineItem', id: string, slot: { __typename?: 'ItemSlot', id: string, name: string } }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined }> }> }, enumDetails: { __typename?: 'AllEnumDetails', readyPlanOptionGroupPersonalizationType: Array<{ __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string }> } };

export type DeactivatePersonalizationGroupMutationVariables = Types.Exact<{
  rpogId: Types.Scalars['ID']['input'];
}>;


export type DeactivatePersonalizationGroupMutation = { __typename?: 'Mutation', savePersonalizationOptionGroup: { __typename?: 'SavePersonalizationOptionGroupResult', version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } };

export type DesignPackagePersonalizationGroupsPage_DesignPackageFragment = { __typename?: 'DesignPackage', id: string, displayName: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } }>, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, active: boolean, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string } | null | undefined, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, personalizationPlaceholders: Array<{ __typename?: 'TakeoffLineItem', id: string, slot: { __typename?: 'ItemSlot', id: string, name: string } }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined }> }> };

export type DesignPackagePersonalizationGroupsPage_OptionGroupFragment = { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, active: boolean, personalizationType?: { __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string } | null | undefined, location?: { __typename?: 'Location', id: string, name: string } | null | undefined, personalizationPlaceholders: Array<{ __typename?: 'TakeoffLineItem', id: string, slot: { __typename?: 'ItemSlot', id: string, name: string } }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined }> };

export type DesignPackagePersonalizationGroupsPage_EnumDetailsFragment = { __typename?: 'AllEnumDetails', readyPlanOptionGroupPersonalizationType: Array<{ __typename?: 'ReadyPlanOptionGroupPersonalizationTypeDetail', code: Types.ReadyPlanOptionGroupPersonalizationType, name: string }> };

export const DesignPackagePersonalizationGroupsPage_OptionGroupFragmentDoc = gql`
    fragment DesignPackagePersonalizationGroupsPage_OptionGroup on ReadyPlanOptionGroup {
  id
  name
  active
  personalizationType {
    code
    name
  }
  location {
    ...Named
  }
  personalizationPlaceholders {
    id
    slot {
      id
      name
    }
  }
  options {
    id
    materialVariant {
      id
    }
  }
}
    ${NamedFragmentDoc}`;
export const DesignPackagePersonalizationGroupsPage_DesignPackageFragmentDoc = gql`
    fragment DesignPackagePersonalizationGroupsPage_DesignPackage on DesignPackage {
  ...DisplayNamed
  version {
    id
  }
  aggregateVersions {
    ...Versionable
  }
  optionGroups {
    ...DesignPackagePersonalizationGroupsPage_OptionGroup
  }
}
    ${DisplayNamedFragmentDoc}
${VersionableFragmentDoc}
${DesignPackagePersonalizationGroupsPage_OptionGroupFragmentDoc}`;
export const DesignPackagePersonalizationGroupsPage_EnumDetailsFragmentDoc = gql`
    fragment DesignPackagePersonalizationGroupsPage_EnumDetails on AllEnumDetails {
  readyPlanOptionGroupPersonalizationType {
    code
    name
  }
}
    `;
export const DesignPackagePersonalizationGroupsPageDocument = gql`
    query DesignPackagePersonalizationGroupsPage($designPackageId: ID!, $versionId: ID) {
  designPackage(id: $designPackageId, versionId: $versionId) {
    ...DesignPackagePersonalizationGroupsPage_DesignPackage
  }
  enumDetails {
    ...DesignPackagePersonalizationGroupsPage_EnumDetails
  }
}
    ${DesignPackagePersonalizationGroupsPage_DesignPackageFragmentDoc}
${DesignPackagePersonalizationGroupsPage_EnumDetailsFragmentDoc}`;

/**
 * __useDesignPackagePersonalizationGroupsPageQuery__
 *
 * To run a query within a React component, call `useDesignPackagePersonalizationGroupsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackagePersonalizationGroupsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackagePersonalizationGroupsPageQuery({
 *   variables: {
 *      designPackageId: // value for 'designPackageId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useDesignPackagePersonalizationGroupsPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackagePersonalizationGroupsPageQuery, DesignPackagePersonalizationGroupsPageQueryVariables> & ({ variables: DesignPackagePersonalizationGroupsPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackagePersonalizationGroupsPageQuery, DesignPackagePersonalizationGroupsPageQueryVariables>(DesignPackagePersonalizationGroupsPageDocument, options);
      }
export function useDesignPackagePersonalizationGroupsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackagePersonalizationGroupsPageQuery, DesignPackagePersonalizationGroupsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackagePersonalizationGroupsPageQuery, DesignPackagePersonalizationGroupsPageQueryVariables>(DesignPackagePersonalizationGroupsPageDocument, options);
        }
// @ts-ignore
export function useDesignPackagePersonalizationGroupsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DesignPackagePersonalizationGroupsPageQuery, DesignPackagePersonalizationGroupsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignPackagePersonalizationGroupsPageQuery, DesignPackagePersonalizationGroupsPageQueryVariables>;
export function useDesignPackagePersonalizationGroupsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackagePersonalizationGroupsPageQuery, DesignPackagePersonalizationGroupsPageQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignPackagePersonalizationGroupsPageQuery | undefined, DesignPackagePersonalizationGroupsPageQueryVariables>;
export function useDesignPackagePersonalizationGroupsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackagePersonalizationGroupsPageQuery, DesignPackagePersonalizationGroupsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackagePersonalizationGroupsPageQuery, DesignPackagePersonalizationGroupsPageQueryVariables>(DesignPackagePersonalizationGroupsPageDocument, options);
        }
export type DesignPackagePersonalizationGroupsPageQueryHookResult = ReturnType<typeof useDesignPackagePersonalizationGroupsPageQuery>;
export type DesignPackagePersonalizationGroupsPageLazyQueryHookResult = ReturnType<typeof useDesignPackagePersonalizationGroupsPageLazyQuery>;
export type DesignPackagePersonalizationGroupsPageSuspenseQueryHookResult = ReturnType<typeof useDesignPackagePersonalizationGroupsPageSuspenseQuery>;
export type DesignPackagePersonalizationGroupsPageQueryResult = Apollo.QueryResult<DesignPackagePersonalizationGroupsPageQuery, DesignPackagePersonalizationGroupsPageQueryVariables>;
export const DeactivatePersonalizationGroupDocument = gql`
    mutation DeactivatePersonalizationGroup($rpogId: ID!) {
  savePersonalizationOptionGroup(input: {id: $rpogId, active: false}) {
    version {
      id
    }
  }
}
    `;
export type DeactivatePersonalizationGroupMutationFn = Apollo.MutationFunction<DeactivatePersonalizationGroupMutation, DeactivatePersonalizationGroupMutationVariables>;

/**
 * __useDeactivatePersonalizationGroupMutation__
 *
 * To run a mutation, you first call `useDeactivatePersonalizationGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivatePersonalizationGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivatePersonalizationGroupMutation, { data, loading, error }] = useDeactivatePersonalizationGroupMutation({
 *   variables: {
 *      rpogId: // value for 'rpogId'
 *   },
 * });
 */
export function useDeactivatePersonalizationGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivatePersonalizationGroupMutation, DeactivatePersonalizationGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeactivatePersonalizationGroupMutation, DeactivatePersonalizationGroupMutationVariables>(DeactivatePersonalizationGroupDocument, options);
      }
export type DeactivatePersonalizationGroupMutationHookResult = ReturnType<typeof useDeactivatePersonalizationGroupMutation>;
export type DeactivatePersonalizationGroupMutationResult = Apollo.MutationResult<DeactivatePersonalizationGroupMutation>;
export type DeactivatePersonalizationGroupMutationOptions = Apollo.BaseMutationOptions<DeactivatePersonalizationGroupMutation, DeactivatePersonalizationGroupMutationVariables>;